/**
 * @Author: 韩祺涛
 * @Date: 2022-12-01
 * @Project: 杭氧客户现场使用
 */
export default {
  state: {
    gasManagementCompanyId: {}
  },
  getters: {
    gasManagementCompanyId: state => state.gasManagementCompanyId
  },
  mutations: {
    gasManagementCompanyId: (state, data) => {
      state.gasManagementCompanyId = data
    }
  },
  actions: {
    handleGasManagementCompanyId (gasManagementCompanyId, data) {
      gasManagementCompanyId.commit('gasManagementCompanyId', data)
    }
  }
}
